export const SUPPORT_URL = 'https://support.eluve.com/';

export const SUPPORT_URL_EXTENSION =
  'https://support.eluve.com/en/articles/14856389-eluve-extension';

export const SUPPORT_URL_TROUBLESHOOTING_EHR_IMPORTS =
  'https://support.eluve.com/en/articles/14590111-troubleshooting-ehr-imports';

export const SUPPORT_URL_DATA_PROTECTION_POLICIES =
  'https://support.eluve.com/en/articles/11391715-data-protection-policies';
